/**
 * 앱 커스텀
 * 사이트별 커스텀 설정은 src\siteCustoms 에 작성한다.
 * ! 사이트가 추가될 때마다 불필요한 설정을 안하도록 구현한다.
 */

import { createContext } from 'react';
import * as siteCustoms from 'siteCustoms';
import packageJson from '../../package.json';

/**
 * 문자열의 첫 글자를 대문자로 변환한 값을 리턴한다.
 * @param {string} str 변환할 문자
 * @returns string
 */
function capitalizeFirstLetter(str) {
  if (!str) {
    return str;
  }
  return str[0].toUpperCase() + str.slice(1);
}

/**
 * 사이트네임 camel case로 변환한다. 예: hanabank-dev > hanabankDev
 * ! 사이트네임이 문자열 조합형인 경우 `-`로 구분되어야 한다.
 * @returns string
 */
function newPreid() {
  return packageJson.config.preid.split('-').reduce((acc, cur, index) => {
    if (index === 0) {
      return cur;
    }
    return acc + capitalizeFirstLetter(cur);
  }, '');
}

const preid = packageJson.config?.preid ? newPreid(packageJson.config.preid) : undefined;
const customized = siteCustoms[preid];

let config;
if (preid && customized) {
  config = { ...siteCustoms.basic, ...customized };
} else {
  config = { ...siteCustoms.basic };
}

const ConfigContext = createContext(config);

export default ConfigContext;
